<template>
  <div>
    <NavTop ref="childRef" :parentData="this.$route.params.parentId" class="navbar"></Navtop>
    <!--  -->
<!--    <div class="content">-->
      <!--      <DetailedPage></DetailedPage>-->
<!--      <div class="title">-->
<!--        <div>{{detailData.authorName}}</div>-->
        <!--        <div style="font-size: 15px;color: #cccccc;">MKS</div>-->
<!--      </div>-->

    <div class="whole">
      <DetailedPage></DetailedPage>
<!--      <DetailedPage :parentData="this.$route.params.parentId" :navigation="true" :tabBarData="this.$route.params.tabBarId"></DetailedPage>-->
      <div class="detailContent">
        <div class="box_title">
          <div class="box_title_l">{{ bigTitle }}</div>
          <div class="box_title_r">
            <span class="title_r_span1" @click="child">首页</span>/
            <span>{{ bigTitle }}</span>
          </div>
        </div>
        <div class="detailContent_title">{{ detailData.title }}</div>
        <div class="detailContent_time">
          作者：{{ detailData.authorName }}&nbsp;|&nbsp;{{ extractDate(detailData.publishTime) }}
        </div>
        <div v-if="detailData.introduce" class="ql-editor" v-html="detailData.introduce"></div>
        <div v-if="detailData.content" class="ql-editor" v-html="detailData.content"></div>
<!--        <el-link class="fujian" :underline="false" v-if="detailData.attachment" :href="detailData.attachment"-->
<!--                 target="_blank" type="primary">附件-->
<!--        </el-link>-->
        <div v-for="(item,index) in attachment" :key="index">
          <el-link class="fujian" :underline="false" v-if="item.url" :href="item.url" target="_blank" type="primary">
            {{ item.title }}
          </el-link>
        </div>
      </div>
    </div>

    <!-- 页面导航 -->
    <div class="pageNav content">
      <div class="pageNav_o">
        <span>上一篇：</span>
        <span v-if="onData.title" @click="goTiaoZ('1')">{{ onData.title }}</span>
        <span v-if="!onData.title">没有更多了</span>
      </div>
      <div class="pageNav_t">
        <span>下一篇：</span>
        <span v-if="underData.title" @click="goTiaoZ('2')">{{ underData.title }}</span>
        <span v-if="!underData.title">没有更多了</span>
      </div>
    </div>
    </div>
<!--  </div>-->
</template>
<script>
import home from '../../../api/home.js'

export default {
  data () {
    return {
      // 大标题
      bigTitle: '',
      title: '学校首页新闻',
      // 二
      two: {
        to: '',
        text: ''
      },
      // 三
      three: {
        to: '',
        text: '学校首页新闻'
      },
      // 数据
      detailData: {},
      // 上一篇
      onData: {},
      // 下一篇
      underData: {},
      // 附件
      attachment: []
    }
  },
  created () {
    console.log(this.$route.params.parentId)
    console.log(this.$route.params.tabBarId)
    // 获取详情
    this.getDetail(this.$route.params.id)
    /**
     *  导航 分页
     * */
    this.getTabBarOne(this.$route.params.id)
    this.getPreviousPage(this.$route.params.id)
    this.getNextPage(this.$route.params.id)
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.id': function (newVal, oldVal) {
      // 当 $route.params.val 发生变化时，这个函数会被调用
      console.log(this.$route.params.id, this.$route.params.tabBarId, 'lllll')
      // 在这里处理变化
      // 获取详情
      this.getDetail(this.$route.params.id)
      /**
       *  导航 分页
       * */
      this.getTabBarOne(this.$route.params.id)
      this.getPreviousPage(this.$route.params.id)
      this.getNextPage(this.$route.params.id)
    }
  },
  methods: {
    /**
     * 获取单个导航栏
     * */
    getTabBarOne (id) {
      home.getTabBarOne({id})
        .then(res => {
          this.bigTitle = res.data.name
        })
        .catch(e => {
          console.log(e)
        })
    },
    /**
     * 查询上一页
     * */
    getPreviousPage (id) {
      home.getPreviousPage({id})
        .then(res => {
          if (res.previous) {
            this.onData = res.previous
          } else {
            this.onData.title = '没有更多了'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 查询下一页
     * */
    getNextPage (id) {
      home.getNextPage({id})
        .then(res => {
          if (res.next) {
            this.underData = res.next
          } else {
            this.underData = '没有更多了'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 上下篇跳转
    goTiaoZ (val) {
      if (val == 1) {
        if (this.onData.title != '没有更多了') {
          this.$router.push('/basic/detail' + '/' + this.$route.params.parentId + '/' + this.onData.tabBarId + '/' + this.onData.id)
          return
        }
      }
      if (val == 2) {
        if (this.underData.title != '没有更多了') {
          this.$router.push('/basic/detail' + '/' + this.$route.params.parentId + '/' + this.underData.tabBarId + '/' + this.underData.id)
          return
        }
      }
    },
    // 获取详情
    async getDetail (id) {
      const res = await home.getDetail({id: id})
      if (res.code == 200) {
        this.detailData = res.data
        console.log(this.detailData, 'detailData')
      }
      let arr = []
      const pattern = /附件\d+[^0-9]+/
      if (res.data.attachment) {
        arr = res.data.attachment.split(',')
        // console.log(arr)
        if (arr.length != 0) {
          arr.forEach(el => {
            if (!el) return
            this.attachment.push({
              url: el,
              title: el.match(pattern)[0]
            })
          })
        }
      }
      console.log(res)
    },
    // 子组件方法
    child () {
      this.$refs.childRef.erJi()
    },
    // 跳转
    routerpush (to) {
      this.$router.push(to)
    },
    // 截取日期
    extractDate (dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
    },
    // 定义方法来截取年和月，并连在一起
    getYearMonth (date) {
      if (!date) {
        return ''
      }
      // 使用正则表达式匹配并返回年和月
      const match = date.match(/^(\d{4})-(\d{2})/)
      if (match) {
        return `${match[1]}-${match[2]}` // 将年和月连在一起返回
      }
      return '' // 如果没有匹配，返回空字符串
    }
  }
}
</script>
<style lang="less" scoped>
.whole {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  height: auto !important;
}

.detailContent {
  display: flex;
  flex-direction: column;
  width: 960px;
  padding-bottom: 20px;
  padding-top: 50px;
  box-sizing: content-box;
  .box_title {
    width: 960px;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;

    .box_title_l {
      padding: 0 15px;
      line-height: 45px;
      font-size: 20px;
      font-weight: bold;
      color: #444;
      border-bottom: 2px solid #9e070e;
    }

    .box_title_r {
      font-size: 14px;
      color: #666;

      .title_r_span1 {
        cursor: pointer;
        color: #666;

        &:hover {
          text-decoration: underline;
        }
      }

      .title_r_span2 {
        cursor: pointer;
        color: #666;

        &:hover {
          text-decoration: underline;
        }
      }

      .title_r_span3 {
        cursor: pointer;
        color: #666;
      }
    }
  }

  .detailContent_title {
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
  }

  .detailContent_time {
    line-height: 30px;
    font-size: 14px;
    color: #666;
  }

  .detailContent_con {
    padding-top: 20px;
  }

  .ql-editor {
    display: block !important;
  }
  .fujian{
    display: block !important;
    &:hover{
      text-decoration: underline;
    }
  }
}

//页面导航
.pageNav {
  border-top: 1px solid #eee;
  margin-top: 20px;
  height: 80px;
  line-height: 80px;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;

  .pageNav_o {
    display: flex;
    align-items: center;
    max-width: 30%;

    span {
      display: inline-block;

      &:nth-child(1) {
        font-size: 12px;
        color: #999;
      }

      &:nth-child(2) {
        color: #999;
        font-size: 14px;
        cursor: pointer;
        display: inline-block;
        width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          color: #7c2c2c;
        }
      }
    }
  }

  .pageNav_t {
    .pageNav_o
  }
}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e;
    color: #fff;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.dropdown:hover {
  background-color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/views/basic/detail/detail.vue